/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum REGIONS {
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  GB = 'GB',
  NZ = 'NZ',
  US = 'US',
  ZA = 'ZA',
}

export enum LANGUAGES {
  de = 'de',
  en = 'en',
  fr = 'fr',
  it = 'it',
}

export enum LOCALES {
  de_ch = 'de-CH',
  de_de = 'de-DE',
  en_ca = 'en-CA',
  en_ch = 'en-CH',
  en_de = 'en-DE',
  en_gb = 'en-GB',
  en_nz = 'en-NZ',
  en_us = 'en-US',
  en_za = 'en-ZA',
  fr_ca = 'fr-CA',
  fr_ch = 'fr-CH',
  it_ch = 'it-CH',
}

export enum DOMAINS {
  ca = '.ca',
  ch = '.ch',
  de = '.de',
  uk = '.co.uk',
  nz = '.co.nz',
  com = '.com',
  za = '.co.za',
}

export enum CURRENCY_CODE_FORMAT {
  de_ch = 'CHF',
  de_de = 'EUR',
  en_ca = 'CAD',
  en_ch = 'CHF',
  en_de = 'EUR',
  en_gb = 'GBP',
  en_nz = 'NZD',
  en_us = 'USD',
  en_za = 'ZAR',
  fr_ca = 'CAD',
  fr_ch = 'CHF',
  it_ch = 'CHF',
}

export enum MONEY_FORMAT {
  de_ch = 'CHF',
  de_de = '€EU',
  en_ca = '$CA',
  en_ch = 'CHF',
  en_de = '€EU',
  en_gb = 'GB£',
  en_nz = 'NZ$',
  en_us = '$US',
  en_za = 'ZAR',
  fr_ca = 'CA$',
  fr_ch = 'CHF',
  it_ch = 'CHF',
}

export const CURRENCY_PREFIX = {
  [LOCALES.de_ch]: 'CHF',
  [LOCALES.de_de]: '€',
  [LOCALES.en_ca]: '$',
  [LOCALES.en_ch]: 'CHF',
  [LOCALES.en_de]: '€',
  [LOCALES.en_gb]: '£',
  [LOCALES.en_nz]: 'NZD',
  [LOCALES.en_us]: '$',
  [LOCALES.en_za]: 'ZAR',
  [LOCALES.fr_ca]: '$',
  [LOCALES.fr_ch]: 'CHF',
  [LOCALES.it_ch]: 'CHF',
};

export type LocaleData = {
  code: LOCALES;
  region: REGIONS;
  language: LANGUAGES;
  moneyFormat?: MONEY_FORMAT;
  currencyCodeFormat?: CURRENCY_CODE_FORMAT;
};

export type SupportedReadableRegions = {
  CA: string;
  CH: string;
  DE: string;
  GB: string;
  NZ: string;
  US: string;
  ZA: string;
};

export type SupportedReadableLanguages = {
  de?: string;
  en?: string;
  fr?: string;
  it?: string;
};
